import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "./NotFound.module.css";

const NotFound = () => {
  return (
    <div className={styles.notFoundContainer}>
      <Helmet>
        <title>Page Not Found - Scadel Furniture</title>
        <meta
          name="description"
          content="The page you are looking for doesn't exist. Return to Scadel Furniture homepage for premium commercial furniture."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className={styles.content}>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className={styles.homeButton}>
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
